import type { CommuneNpdc, CommunePriority } from '../types/Commune'
import { isCommuneSeoUnlocked } from './localRollout'

export type LocalContentTier = 'premium' | 'standard' | 'light'

/** Toutes les communes du fichier (P0–P3) : sitemap + robots index. Le palier change le volume de contenu, pas l’indexation. */
const INDEXABLE_PRIORITIES: CommunePriority[] = ['P0', 'P1', 'P2', 'P3']

/** Communes indexables (sitemap + robots index). */
export function shouldIndexCommune(commune: CommuneNpdc | undefined): boolean {
  if (!isCommuneSeoUnlocked(commune)) return false
  return INDEXABLE_PRIORITIES.includes(commune!.priorite || 'P3')
}

export function isCommuneIndexable(priorite: CommunePriority | undefined): boolean {
  return !!priorite && INDEXABLE_PRIORITIES.includes(priorite)
}

/** Profondeur de contenu selon la priorité géo (pas de blocage d’indexation). */
export function getContentTier(priorite: CommunePriority, _commune?: CommuneNpdc): LocalContentTier {
  if (priorite === 'P0' || priorite === 'P1') return 'premium'
  if (priorite === 'P2') return 'standard'
  return 'light'
}

/** Variante 0–2 pour diversifier les intros P2. */
export function getIntroVariantIndex(slug: string): number {
  let hash = 0
  for (let i = 0; i < slug.length; i++) {
    hash = (hash + slug.charCodeAt(i) * (i + 1)) % 997
  }
  return hash % 3
}
